// extracted by mini-css-extract-plugin
module.exports = {"Personnel":"Personnel_Personnel__3gZh2","Person":"Personnel_Person__163Ok","Row":"Personnel_Row__3CLJa","Item":"Personnel_Item__kD28N"};